var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.125V4.125C10.5 3.91789 10.3321 3.75 10.125 3.75H1.875C1.66789 3.75 1.5 3.91789 1.5 4.125V13.125C1.5 13.3321 1.66789 13.5 1.875 13.5H3M10.5 13.125C10.5 13.3321 10.3321 13.5 10.125 13.5H6M10.5 13.125V6.375C10.5 6.16789 10.6679 6 10.875 6H13.3447C13.4441 6 13.5395 6.03951 13.6098 6.10984L16.3902 8.89017C16.4605 8.96049 16.5 9.05587 16.5 9.15533V13.125C16.5 13.3321 16.3321 13.5 16.125 13.5H15M10.5 13.125C10.5 13.3321 10.6679 13.5 10.875 13.5H12M3 13.5C3 14.3284 3.67157 15 4.5 15C5.32843 15 6 14.3284 6 13.5M3 13.5C3 12.6716 3.67157 12 4.5 12C5.32843 12 6 12.6716 6 13.5M12 13.5C12 14.3284 12.6716 15 13.5 15C14.3284 15 15 14.3284 15 13.5M12 13.5C12 12.6716 12.6716 12 13.5 12C14.3284 12 15 12.6716 15 13.5",
    stroke: "#3589A5",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdd);
export default __webpack_public_path__ + "static/media/ndd.22ea139e52522e5a571b64795e5ff979.svg";
export { ForwardRef as ReactComponent };